import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'
import { useTableActions } from '../../../../components/tables/MultiSelectTableContext'

const MUTATION = gql`
  mutation RemoveDynamicServiceOrders($ids: [Int]) {
    removeDynamicServiceOrders(ids: $ids)
  }
`

export const useRemoveDynamicServiceOrders = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['DynamicServiceOrders', 'DynamicServiceOrdersCount'],
    client: serviceOrdersClient
  })
  const notify = useNotification()
  const modal = useAlert()
  const closeModal = useCloseModal()
  const { clearSelection } = useTableActions()
  const { t } = useTranslation('common')

  const handleRequest = ids => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { ids } }).then(resp => {
      if (!resp.errors) {
        if (clearSelection) clearSelection()
        if (closeModal) closeModal()
      } else {
        notify.error({ title: t('errorDelete') })
      }
    })
  }

  return [handleRequest, state]
}
